import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Background from "../../../../assets/images/header/background1.webp";
import Footer from "../../footer/Footer";
import i18n from "../../../../i18n";
import NavBar from "../../navbar/Navbar";

function About() {
  const { t } = useTranslation();
  const [isRTL, setIsRTL] = useState(i18n.language === "ar");

  useEffect(() => {
    const handleLanguageChange = (lng) => {
      setIsRTL(lng === "ar");
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  return (
    <div
      className="page-container d-flex flex-column min-vh-100"
      style={{
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background image */}
      <div
        className="position-absolute w-100 h-100"
        style={{
          top: 0,
          left: 0,
          zIndex: -1,
        }}
      >
        <img
          src={Background}
          alt="background"
          className="w-100 h-100"
          style={{
            objectFit: "cover",
          }}
        />
      </div>

      <div style={{ position: "relative", zIndex: 10 }}>
        <NavBar />
      </div>

      <main
        className="main-content flex-grow-1"
        style={{ position: "relative", zIndex: 5 }}
      >
        <div className="container-fluid py-3 py-md-5 px-3 px-md-5">
          <div className="row justify-content-center">
            <div className="col-12 col-md-11 col-lg-10 col-xl-9">
              <div dir={isRTL ? "rtl" : "ltr"} className="text-white">
                {/* 🔴 Titre: on utilise la clé nav.about */}
                <h2
                  className={`${
                    isRTL ? "text-end" : "text-start"
                  } fw-bold mb-3 mb-md-4 fs-3 fs-md-2`}
                  style={{
                    color: "#00FF00",
                  }}
                >
                  {t("nav.about")}
                </h2>

                {/* Paragraphe long: on garde "About Us" */}
                <div className="d-flex flex-column align-items-start px-2 px-md-4 py-3 py-md-4">
                  <p
                    className={`${
                      isRTL ? "text-end" : "text-start"
                    } lh-base lh-md-1.6 fs-6 fs-md-5`}
                    style={{
                      textAlign: "justify",
                    }}
                  >
                    {t("About Us")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer className="mt-auto" style={{ position: "relative", zIndex: 10 }}>
        <Footer />
      </footer>
    </div>
  );
}

export default About;
